<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancelChanges()">Cancel</ion-button>
    </ion-buttons>
    <ion-title>{{ title() }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirmChanges()">Done</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar (ionInput)="searchbarInput($event)"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	  <ion-radio-group [(ngModel)]="selectedValue" (ionChange)="onValueChanged($event.detail.value)">
    @for (item of filteredItems; track item[displayValue()]) {
	    <ion-item>
      <ion-radio [value]="item"
                 [name]="item[displayValue()]">{{ item[displayValue()] }}</ion-radio>
    </ion-item>
    }
	  </ion-radio-group>
</ion-content>
